import { render, staticRenderFns } from "./TagComponent.vue?vue&type=template&id=0ea5b021&scoped=true"
import script from "./TagComponent.vue?vue&type=script&lang=js"
export * from "./TagComponent.vue?vue&type=script&lang=js"
import style0 from "./TagComponent.vue?vue&type=style&index=0&id=0ea5b021&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea5b021",
  null
  
)

export default component.exports